<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="900px"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon 
        v-on="on"
      >
        <v-icon color="primary">
          mdi-clipboard-check
        </v-icon>
      </v-btn>
    </template>
    <material-card
      :offset="10"
      :full-width="true"
      color="hrissecondary"
      :title="position.name"
      text="Edit Position Approval Settings"
      class="mb-0"
    >
      <form v-if="dialog">
        <v-container>
          <div>
            <v-tabs
              v-model="active"
            >
              <v-tab
                v-for="item in filteredTabItems"
                :key="item.name"
              >
                {{ item.name }}
              </v-tab>
            </v-tabs>

            <v-tabs-items v-model="active">
              <v-tab-item class="pb-12">
                <leave-approval-level-authority-container-view
                  :position="position"
                  @close-dialog="closeDialog" 
                />
              </v-tab-item>

              <v-tab-item class="pb-12">
                <claim-approval-level-authority-container-view
                  :position="position"
                  @close-dialog="closeDialog" 
                />
              </v-tab-item>
            </v-tabs-items>
          </div>
        </v-container>
      </form>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      LeaveApprovalLevelAuthorityContainerView: () => import('@/components/hris/setup/job-position/job-title/LeaveApprovalLevelAuthorityContainerView'),
      ClaimApprovalLevelAuthorityContainerView: () => import('@/components/hris/setup/job-position/job-title/ClaimApprovalLevelAuthorityContainerView'),
    },
    props: {
      position: { 
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        dialog: null,
        progressing: false,
        tabItems: [{ name: 'Leave Types' }],
        active: 0,
      }
    },
    computed: {
      filteredTabItems () {
        let modifiedTab = [...this.tabItems]
 
        if (this.$hasPermissionTo(['view claim types'])) {
          modifiedTab.push({ name: 'Claim Types' })
        }

        return modifiedTab
      },
    },
    methods: {
      closeDialog () {
        this.dialog = false
      },
    },
  }
</script>
